import React from 'react'
import { concat } from 'ramda'
import { useQuery } from 'react-apollo'
import { ACCOUNT_SCREENS, SIGN_UP_SCREENS, MODALS } from '../../../constants'
import {
  facebookSelector,
  instagramSelector,
  tiktokSelector
} from '../../../selectors/config'
import { findLinks, findSection } from '../utils/navigation-links-helpers'
import { getModalLocation } from '../../../lib/modal'
import NAV_FOOTER_QUERY from '../../../../graphql/queries/navigation-footer.gql'
import NavigationFooter from './navigation-footer'
import NavigationFooterKids from './navigation-footer-kids'
import { useConfig } from '../../../hooks/use-config'
import { useIsAuthenticated } from '../../../hooks/use-is-authenticated'
import { useIsKid } from '../../../hooks/use-is-kid'

function NavigationFooterWrapper({ location }) {
  const isAuthenticated = useIsAuthenticated()
  const isKid = useIsKid()
  const { appConfig } = useConfig()
  const { data } = useQuery(NAV_FOOTER_QUERY, {
    fetchPolicy: 'cache-only'
  })

  if (!data) return null
  const { navFooter } = data

  const dynamicTopLinks = findLinks('footer.top_links', navFooter)
  const messageSection =
    findSection('footer.message', navFooter) || placeholderMessageSection
  const bottomLinks = findLinks('footer.bottom_links', navFooter)
  const staticNavItems = createStaticNavItems(isAuthenticated, location)
  const topLinks = concat(dynamicTopLinks, staticNavItems)
  const facebookUsername = facebookSelector(appConfig)
  const instagramUsername = instagramSelector(appConfig)
  const tiktokUsername = tiktokSelector(appConfig)

  if (isKid) {
    return (
      <NavigationFooterKids
        bottomLinks={bottomLinks}
        messageSection={messageSection}
      />
    )
  }
  return (
    <NavigationFooter
      bottomLinks={bottomLinks}
      messageSection={messageSection}
      topLinks={topLinks}
      facebookUsername={facebookUsername}
      instagramUsername={instagramUsername}
      tiktokUsername={tiktokUsername}
    />
  )
}
export default NavigationFooterWrapper

const placeholderMessageSection = {
  __typename: 'NavContent',
  children: [
    {
      __typename: 'NavContent',
      content: 'Marketing and Legal Copy',
      name: 'footer.message'
    }
  ],
  name: 'footer.message'
}

const createStaticNavItems = (isAuthenticated, location) => {
  if (isAuthenticated) {
    return [
      {
        isRental: false,
        isDiscoverNav: false,
        name: ACCOUNT_SCREENS.MY_ACCOUNT.name,
        path: ACCOUNT_SCREENS.MY_ACCOUNT.path,
        target: null,
        type: 'SCREEN_ID',
        __typename: 'NAV_ITEM'
      }
    ]
  }

  return [
    {
      isRental: false,
      isDiscoverNav: false,
      name: SIGN_UP_SCREENS.SIGN_UP.name,
      path: SIGN_UP_SCREENS.SIGN_UP.path,
      target: null,
      type: 'SCREEN_ID',
      __typename: 'NAV_ITEM'
    },
    {
      isRental: false,
      isDiscoverNav: false,
      name: 'Log In',
      path: getModalLocation(location, MODALS.qsParams.login),
      target: null,
      type: 'SCREEN_ID',
      __typename: 'NAV_ITEM'
    }
  ]
}
